// src/helpers/factories/menu/cardFactories/specials/index.ts
var specialItemsFactoryCore = (items, menuTypeAssignedItemIds, handleDeleteItem) => {
  return menuTypeAssignedItemIds.map((id) => {
    const item = items[id];
    if (item)
      return {
        id: item.itemId,
        title: item.name,
        onDelete: handleDeleteItem,
        onPress: () => console.info(id),
        entity: "item" /* ITEM */
      };
    else
      return null;
  }).filter((value) => value !== null);
};
var specialCombosFactoryCore = (combos, menuTypeAssignedComboIds, handleDeleteItem) => {
  return menuTypeAssignedComboIds.map((id) => {
    const item = combos[id];
    if (item)
      return {
        id: item.comboId,
        title: item.name,
        onDelete: handleDeleteItem,
        onPress: () => console.info(id),
        entity: "combo" /* COMBO */
      };
    else
      return null;
  }).filter((value) => value !== null);
};

export { specialCombosFactoryCore, specialItemsFactoryCore };
